import * as React from "react";
import { Image, tokens, makeStyles, shorthands, Text } from "@fluentui/react-components";

export interface HeaderProps {
  title: string;
  logo: string;
  message: string;
}

const useStyles = makeStyles({
  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    ...shorthands.padding(tokens.spacingVerticalXXXL, tokens.spacingVerticalXL),
    backgroundColor: tokens.colorBrandBackground,
    background: `linear-gradient(135deg, ${tokens.colorBrandBackground} 0%, ${tokens.colorBrandBackground2} 100%)`,
    position: 'relative',
    ...shorthands.overflow('hidden'),
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `radial-gradient(circle at 20% 50%, ${tokens.colorBrandBackground2} 0%, transparent 50%)`,
      opacity: 0.5,
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `radial-gradient(circle at 80% 50%, ${tokens.colorBrandBackground2} 0%, transparent 50%)`,
      opacity: 0.3,
    }
  },
  content: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: tokens.spacingVerticalL,
  },
  logo: {
    ...shorthands.borderRadius('50%'),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.padding(tokens.spacingVerticalS),
    boxShadow: tokens.shadow16,
  },
  message: {
    fontSize: tokens.fontSizeHero900,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralBackground1,
    textAlign: 'center',
    textShadow: `0 2px 4px rgba(0, 0, 0, 0.2)`,
  },
  subtitle: {
    color: tokens.colorNeutralBackground1,
    opacity: 0.9,
    textAlign: 'center',
  }
});

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { title, logo, message } = props;
  const styles = useStyles();

  return (
    <header className={styles.header}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <Image width="80" height="80" src={logo} alt={title} />
        </div>
        <h1 className={styles.message}>{message}</h1>
        <Text size={400} className={styles.subtitle}>
          Your intelligent email management assistant
        </Text>
      </div>
    </header>
  );
};

export default Header;